<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Dashboard</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
        </div>
      </div>
      <!--container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <!--First Row-->
        <div class="row">
          <div class="col-md-3" v-for="(item, index) in top_count_data" :key="index">
            <div class="info-box">
              <span class="info-box-icon">
                <img :src="item.icon" alt="icon" style="width: 60%;" />
              </span>
              <div class="info-box-content">
                <span class="info-box-text"> <a :href="item.link">{{ item.title }}</a></span>
                <span class="info-box-number">{{ item.count }}</span>
              </div>
            </div>
          </div>
        </div>
        <!--2nd Count Row-->
        <div class="row">
          <div class="col-md-3" v-for="(item, index) in rates_data" :key="index">
            <div class="info-box">
              <span class="info-box-icon">
                <img :src="item.icon" alt="icon" style="width: 60%;" />
              </span>
              <div class="info-box-content">
                <span class="info-box-text"> <a :href="item.link">{{ item.title }}</a></span>
                <span class="info-box-number">{{ item.count }}</span>
              </div>
            </div>
          </div>
        </div>

        <!--2nd row -->
        <div class="row">
          <div class="col-9">
            <div class="row">
              <div class="col-12">
                <div id="view-click-data-graph" class="bg-white d-flex justify-content-center align-items-center" style="margin: 0px 0px 15px 0px; height: 370px;">
                  <div class="spinner-border m-5" role="status">
                    <span class="visually-hidden"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="row">
              <div class="col-12" v-for="(item, index) in budgets_data" :key="index">
                <div class="info-box">
                  <span class="info-box-icon">
                    <img :src="item.icon" alt="icon" style="width: 60%;" />
                  </span>
                  <div class="info-box-content">
                    <span class="info-box-text"> <a :href="item.link">{{ item.title }}</a></span>
                    <span class="info-box-number">{{ item.count }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Budget Data-->
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <div id="divice-wise-data" class="bg-white d-flex justify-content-center align-items-center" style="margin: 0px 0px 15px 0px; height: 400px;">
                  <div class="spinner-border m-5" role="status">
                    <span class="visually-hidden"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!--Os Comparism statistics-->
            <div class="row">
              <div class="col-12">
                <div id="os-wise-data" class="bg-white d-flex justify-content-center align-items-center" style="margin: 0px 0px 15px 0;height: 400px;">
                  <div class="spinner-border m-5" role="status">
                    <span class="visually-hidden"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Zone wise Comparism statistics-->
        <div class="row">
          <div class="col-12">
            <div id="zone-wise-data" class="bg-white d-flex justify-content-center align-items-center" style="margin: 0px 0px 15px 0; height: 400px;">
              <div class="spinner-border m-5" role="status">
                <span class="visually-hidden"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import localStorage from "@/services/localStorage";
import axios from 'axios';
import Highcharts from 'highcharts';

export default {
  name: 'Dashboard',
  metaInfo: {
    title: 'Dashboard | Dotlines'
  },
  data: () => ({
    top_count_data: [],
    rates_data: [],
    budgets_data: [],
    count_statistics_data: {},
    device_wise_view_count: [],
    os_wise_view_count: [],
    zone_wise_view_data: {},
    api_url: '',
    is_loading: false,
    has_permission: true
  }),
  mounted () {
    if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click')
    }
    const windowReload = localStorage.get('window_reload')
    if (windowReload) {
      localStorage.set('window_reload', false)
      window.location.reload()
    }
    this.api_url = '/get-top-count-data'
    this.loadTopCountData()
    this.loadRatesData()
    this.loadBudgetData()

    this.loadCountStatistics()
    this.loadDeviceWiseViewCount()
    this.loadOsWiseViewCount()
    this.loadZoneWiseViewCount()
  },
  methods: {
    loadTopCountData () {
      this.is_loading = true;
      let query = { ...this.filter, ...this.$route.query }
      this.getTopCountData(query).then(response => {
        this.top_count_data = response.data
      }).finally(() => {
        this.is_loading = false
      });
    },
    loadRatesData () {
      this.is_loading = true
      let query = {}
      this.getRatesData(query).then(response => {
        this.rates_data = response.data
      }).finally(() => {
        this.is_loading = false
      });
    },
    loadRatesData () {
      this.is_loading = true
      let query = {}
      this.getRatesData(query).then(response => {
        this.rates_data = response.data
      }).finally(() => {
        this.is_loading = false
      });
    },
    loadBudgetData () {
      this.is_loading = true
      let query = {}
      this.getBudgetData(query).then(response => {
        this.budgets_data = response.data
      }).finally(() => {
        this.is_loading = false
      });
    },
    loadCountStatistics () {
      this.is_loading = true
      let query = {}
      this.getCountStatistics(query).then(response => {
        this.count_statistics_data = response.data
        this.viewClickDataChat()
      }).finally(() => {
        this.is_loading = false
      });
    },
    loadDeviceWiseViewCount () {
      this.is_loading = true
      let query = {}
      this.getDeviceWiseViewCount(query).then(response => {
        this.device_wise_view_count = response.data
        this.deviceWiseDataChat()
      }).finally(() => {
        this.is_loading = false
      });
    },
    loadOsWiseViewCount () {
      this.is_loading = true
      let query = {}
      this.getOsWiseViewCount(query).then(response => {
        this.os_wise_view_count = response.data
        this.osWiseDataChat()
      }).finally(() => {
        this.is_loading = false
      });
    },
    loadZoneWiseViewCount () {
      this.is_loading = true
      let query = {}
      this.getZoneWiseViewCount(query).then(response => {
        this.zone_wise_view_data = response.data
        this.zoneWiseDataChat()
      }).finally(() => {
        this.is_loading = false
      });
    },
    getTopCountData (query = null) {
      return new Promise((resolve, reject) => {
        axios.get(this.api_url, {
          params: query
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false
          }
          reject(error);
        })
      })
    },
    getRatesData (query = null) {
      return new Promise((resolve, reject) => {
        axios.get('/get-rate-data', {
          params: query
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false
          }
          reject(error)
        })
      })
    },
    getBudgetData (query = null) {
      return new Promise((resolve, reject) => {
        axios.get('/get-budget-data', {
          params: query
        }).then(response => {
          resolve(response.data);
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false;
          }
          reject(error);
        })
      })
    },
    getCountStatistics (query = null) {
      return new Promise((resolve, reject) => {
        axios.get('/get-count-static', {
          params: query
        }).then(response => {
          resolve(response.data);
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false;
          }
          reject(error);
        })
      })
    },
    getDeviceWiseViewCount (query = null) {
      return new Promise((resolve, reject) => {
        axios.get('/get-device-wise-view-count', {
          params: query
        }).then(response => {
          resolve(response.data);
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false;
          }
          reject(error);
        })
      })
    },
    getOsWiseViewCount (query = null) {
      return new Promise((resolve, reject) => {
        axios.get('/get-os-wise-view-count', {
          params: query
        }).then(response => {
          resolve(response.data);
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false;
          }
          reject(error);
        })
      })
    },
    getZoneWiseViewCount (query = null) {
      return new Promise((resolve, reject) => {
        axios.get('/get-zone-wise-view-vs-click', {
          params: query
        }).then(response => {
          resolve(response.data);
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false;
          }
          reject(error);
        })
      })
    },
    viewClickDataChat () {
      Highcharts.chart('view-click-data-graph', {
        chart: {
          type: 'column'
        },
        colors: ['#93BFEB', '#F5AA85', '#66C2A3'],
        title: {
          text: 'Request vs Impression vs Click (Last 7 Days)'
        },
        xAxis: {
          categories: this.count_statistics_data.categories,
          crosshair: true
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0
          }
        },
        series: this.count_statistics_data.series
      });
    },
    deviceWiseDataChat () {
      // Create the chart
      Highcharts.chart('divice-wise-data', {
        chart: {
          type: 'pie'
        },
        title: {
          text: 'Device wise Impression'
        },
        accessibility: {
          announceNewData: {
            enabled: true
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            }
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
        },
        series: [
          {
            name: "Device",
            colorByPoint: true,
            data: this.device_wise_view_count
          }
        ]
      });

    },
    osWiseDataChat () {
      Highcharts.chart('os-wise-data', {
        chart: {
          type: 'bar'
        },
        title: {
          text: 'Top 10 OS (Impression Wise)'
        },
        accessibility: {
          announceNewData: {
            enabled: true
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            }
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
        },
        series: [
          {
            name: "Impression",
            colorByPoint: true,
            data: this.os_wise_view_count
          }
        ]
      });
    },
    zoneWiseDataChat () {
      Highcharts.chart('zone-wise-data', {
        chart: {
          type: 'bar'
        },
        title: {
          text: 'Zone Wise Impression vs Click'
        },
        xAxis: {
          categories: this.zone_wise_view_data.categories,
          title: {
            text: null
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Traffic',
            align: 'high'
          },
          labels: {
            overflow: 'justify'
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
          shadow: true
        },
        credits: {
          enabled: false
        },
        series: this.zone_wise_view_data.series
      });

    }
  }
}

</script>
